package com.mps.asc_app.domain.bookings

private const val DEFAULT_MAX_FUTURE_BOOKINGS = 3

fun canBookAdditionalFutureSlot(
    activeFutureBookings: Int,
    maxFutureBookings: Int = DEFAULT_MAX_FUTURE_BOOKINGS
): Boolean {
    if (maxFutureBookings <= 0) return false
    return activeFutureBookings < maxFutureBookings
}

